import { ComponentType, lazy } from 'react';

// eslint-disable-next-line
type ComponentModule<P = any> = { default: ComponentType<P> };

const CHUNK_LOAD_TIMEOUT_MS = 8_000;

function createTimeoutPromise(ms: number) {
  let timer: ReturnType<typeof setTimeout>;
  const promise = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => {
      reject(new Error('Loading chunk timed out'));
    }, ms);
  });
  const clear = () => clearTimeout(timer);
  return { promise, clear };
}

const lazyWithRetry = (importFn: () => Promise<ComponentModule>) => {
  return lazy(() => {
    const importWithRetry = importFn().catch(() => {
      return new Promise<ComponentModule>((resolve, reject) => {
        setTimeout(() => {
          importFn().then(resolve).catch(reject);
        }, 10000);
      });
    });

    const { promise: timeout, clear } = createTimeoutPromise(
      CHUNK_LOAD_TIMEOUT_MS
    );

    return Promise.race([importWithRetry, timeout]).finally(clear);
  });
};

export default lazyWithRetry;
